import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { EuroIcon } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { StaffApplicationMarkAsPaidInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<StaffApplicationMarkAsPaidInput> = z.object({
  classifiedAmount: createNumberSchema('Classé sans suite', { isPositive: true }),
  interviewDoneAmount: createNumberSchema('Entretien réalisé', { isPositive: true }),
  pcrId: createNumberSchema('pcr')
})

type StaffApplicationMarkAsPaidFormProps = BaseFormProps<StaffApplicationMarkAsPaidInput> & {
  className?: string
}

const StaffApplicationMarkAsPaidForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: StaffApplicationMarkAsPaidFormProps) => {
  const form = useForm<StaffApplicationMarkAsPaidInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="classifiedAmount"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput
                    {...field}
                    icon={EuroIcon}
                    type="number"
                    label="Classé sans suite"
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="interviewDoneAmount"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput
                    {...field}
                    icon={EuroIcon}
                    type="number"
                    label="Entretien réalisé"
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default StaffApplicationMarkAsPaidForm
